import { colors } from "config/styles/themeColors";

const styles = {
  checkboxWrap: {
    "&.MuiFormGroup-root": {
      width: "fit-content",
      color: "text.secondary",
      "& .MuiFormControlLabel-root": {
        ml: 0,
      },
    },
  },
  checkbox: {
    p: "0 4px 0 0",
    "& .MuiSvgIcon-root": {
      fill: colors.text.secondary,
    },
    "&.Mui-checked >.PrivateSwitchBase-input:focus~.MuiSvgIcon-root>path ": {
      outline: "none",
    },
    "&.Mui-checked .MuiSvgIcon-root": {
      fill: colors.text.secondary,
      outline: "none",
    },
    "&.Mui-checked:hover .MuiSvgIcon-root": {
      fill: colors.gray.main,
    },
  },
};

export default styles;
